//==============================================
// Scroll
//==============================================


// Interaction: Scroll - Header Nav
export let scrollHeader = () =>{

	$(document).on('scroll', function(){

		const docScroll = $(window).scrollTop(),
			HeaderNav = $('.header'),
			HeaderNavHeight = HeaderNav.height();

		//const blockScroll = gsap.timeline();

		if(docScroll > HeaderNavHeight){

			HeaderNav.addClass('header--scroll');
		}else{
			HeaderNav.removeClass('header--scroll');
		}
		
	});
	
	let header = $('.header');
	let gsapStart = 'top 10%';
	let gsapEnd = 'bottom 10%';

	if($('body').hasClass('home')) {
		gsapStart = '50% bottom';
		gsapEnd = '10% top';

	}

	gsap.utils.toArray('.home__section, .section').forEach((section) => {
		
		// ScrollTrigger header -- this requires scrollHeader()
		ScrollTrigger.create({
			trigger: section,
			start: gsapStart,
			end: gsapEnd,
			ease: "none",
			toggleActions: "play none play none",
			duration: 1,
			normalizeScroll: true,
			//markers: true,
			onToggle: self => {

				if(self.trigger.classList.contains('has-background-image') || self.trigger.classList.contains('has-primary-background-color')) {

					header.addClass('header--white');
					header.addClass('header--alt');

				}else{

					header.removeClass('header--white');
					header.removeClass('header--alt');

				}

			}
			
			
		});

	});

}

// Interaction: Scroll - scroll_top visible
export let scrollTopButtonVisible = () =>{

	$(document).on('scroll', function(){
	
		let docScrollUp = $(window).scrollTop();
		

		// Scroll Top
		if(docScrollUp > 450){

			$('.scroll_top').css('opacity', 1);

		}else{

			$('.scroll_top').css('opacity', 0);

		}

	});

}
	
// Interatction: Click - scroll_top
export let scrollTopButton = () =>{

	$('.cms-button-scroll-top').on('click keypress', function(e){

		e.preventDefault();

		$(this).trigger('blur');
		$("html, body").animate({ scrollTop: 0 }, 500);

	});

}

// Interatction: Click - scroll_down
export let scrollDownHome = () =>{

	$('.home__section__intro-header .cms-button--scroll').on('click keypress', function(e){
		let trigger = $("html, body");
		e.preventDefault();

		$(this).trigger('blur');
		
		gsap.to(trigger, {scrollTop: 10, duration: 0.2, ease: 'power1.InOut'});

	});

}


// Interatction: Click - scroll_down
export let jumpLinks = () =>{

	$('.fund__nav__inner-link').on('click keypress', function(e){

		let target = $(this).attr('href'),
			targetTop = $(target).offset().top;

			console.log(targetTop);

		e.preventDefault();

		$(this).trigger('blur');
		$("html, body").animate({ scrollTop: targetTop - 200 }, 500);



	});

}
	

 





